import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../../../../services/home.service';

import Swal from 'sweetalert2';
import { FormGroup } from '@angular/forms';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../../../services/user';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs';

import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ClientsService } from '../../../../services/clients.service';
import { ClientService } from '../../../../services/clients';
import { get } from 'http';
import { DataflowService } from '../../../../services/dataflow';
import { DeviceDetectorService } from '../../../../services/device-detector.service';

@Component({
  selector: 'app-alldataflowclient',
  templateUrl: './alldataflowclient.component.html',
  styleUrl: './alldataflowclient.component.scss'
})
export class AlldataflowclientComponent {


  @Input() isProfile: string = "";

  allData: any[] = [];
  userimage!: string;
  userData!: users;
  username!: string;
  userPhone: string = '';
  userName: string = '';
  profile!: boolean;
  userfirstname: string = '';
  userFacebook: string = '';
  userInstgram: string = '';
  userTiktok: string = '';
  isMobile: boolean = false;
  displayedColumns: string[] = [
    'name',

    'mobile',

    'register_date',
    'dataflow',
    'university',
    'eligibility_res',
    'user',


    'first_class',

    'final_reg',

    'call',
    'chat',

    'options' // لو عايز تسيب زرار الأكشنز
  ];


  contentReady: boolean = true;
  noData: boolean = false;
  showPopUp: boolean = false;
  showRejectPopUp: boolean = false;
  orderchange!: FormGroup;
  reason: string = "";
  orderId!: any;
  statuslist: any;
  clear: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  stockTotal!: any;
  totalItems!: any;
  searched: boolean = false;
  isAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '1')
  );
  isSubAdmin$: Observable<boolean> = this._userService.getAccountType().pipe(
    map(data => this.accountType === '6')
  );
  showoptions: boolean = false;
  searchKey: string = '';
  isAr: boolean = localStorage.getItem("language") == "ar";
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private router: Router,
    private deviceService: DeviceDetectorService,
    private _dataflow: DataflowService,
    private _profileService: ProfileService,
    private excelExportService: ExcelExportService,
    private _userService: UserService,
  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isAdmin$.subscribe(value => console.log('isAdmin:', value));
    this.isMobile = this.deviceService.isMobileDevice();
    if (this.isMobile) {
      this.displayedColumns = [
        'name',
        'mobile',
      ];
    }
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1";
        this.isSubAdmin = this.accountType == "6";
        if (!data['has_access_to_phone_numbers']) {
          const colsToRemove = ['mobile', 'call', 'chat'];
          this.displayedColumns = this.displayedColumns.filter(col => !colsToRemove.includes(col));
        }
        this.getAllClients(10, 1);

      },
      error: (error) => console.error(error),
    });


  }
  search() {
    if (this.searchKey != null && this.searchKey != undefined && this.searchKey != "") {
      this.contentReady = true;
      this._dataflow.search(this.searchKey).subscribe({
        next: (data) => {
     this.allData = data['data'];
        this.stockTotal = data['last_page'];
        this.totalItems = data['total'];

        this.dataSource = new MatTableDataSource(this.allData);
          this.contentReady = false;
          if (this.allData.length === 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
        },
        error: (error) => console.error(error),
      });
    }

  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel('Clients', 'AhmedElshahatClients', ['actions']);
  }
  delete(id: any) {
    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "نعم" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._dataflow.delete(id).subscribe({
          next: (res) => {
            this.getAllClients(10, 1);
          },
          error: (err) => console.log(err),
        });
      }
    });


  }
  edit(itemobj: any) {
    this.router.navigate(['/createdataflow'], { queryParams: itemobj });
  }
  getAllClients(perpage: any, page: any) {
    this.contentReady = true;
    this.searched = false;
    this._dataflow.getAll(perpage, page).subscribe({
      next: (data) => {
        this.allData = data['data'];
        this.stockTotal = data['last_page'];
        this.totalItems = data['total'];

        this.dataSource = new MatTableDataSource(this.allData);
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
  onPaginateChange(event: PageEvent) {
    const newPage = event.pageIndex + 1; // MatPaginator is 0-based
    this.getAllClients(10, newPage);
  }
  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }
  call(phone: any) {
    window.open("tel:+" + phone, '_blank');
  }
  chat(phone: any) {
    // href="https://api.whatsapp.com/send?phone=201012673672"

    window.open("https://api.whatsapp.com/send?phone=2" + phone, '_blank');
  }

}